import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { SEEDKEEPERS_URL } from "@/lib/api";
import { LOGO } from "@/lib/logo";

export default function Footer() {
  return (
    <footer className="bg-rainforest text-cream" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO.markCream} alt="SeedKeepers Academy" className="h-12 w-12 object-contain" />
              <span className="font-serif text-3xl">SeedKeepers Academy</span>
            </div>
            <p className="font-serif text-2xl md:text-3xl font-light leading-snug text-cream/90 max-w-md">
              Learn. Then help build Australia's restoration future.
            </p>
            <a
              href={SEEDKEEPERS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-visit-seedkeepers"
              className="group inline-flex items-center gap-2 mt-8 text-cream/70 hover:text-cream transition-colors text-sm"
            >
              <ArrowLeft size={14} className="transition-transform group-hover:-translate-x-1" />
              Visit SeedKeepers
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="overline text-cream/50 mb-6">Explore</p>
            <ul className="space-y-4 text-cream/80">
              <li><Link to="/approach" className="hover:text-ochre transition-colors">Our Approach</Link></li>
              <li><Link to="/courses" className="hover:text-ochre transition-colors">Courses</Link></li>
              <li><Link to="/on-country" className="hover:text-ochre transition-colors">On-Country Learning</Link></li>
              <li><Link to="/seed-banks" className="hover:text-ochre transition-colors">Seed Banks</Link></li>
              <li><Link to="/library" className="hover:text-ochre transition-colors">Resources</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-cream/50 mb-6">Engage</p>
            <ul className="space-y-4 text-cream/80">
              <li><Link to="/organisations" className="hover:text-ochre transition-colors">For Organisations</Link></li>
              <li><Link to="/about" className="hover:text-ochre transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-ochre transition-colors">Contact</Link></li>
              <li>
                <a href={SEEDKEEPERS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-ochre transition-colors">
                  SeedKeepers <ArrowUpRight size={13} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hair-rule-light mt-20 pt-8 flex flex-col md:flex-row justify-between gap-4 text-sm text-cream/50">
          <p>Proudly created by SeedKeepers.</p>
          <p>© {new Date().getFullYear()} SeedKeepers Academy — A national restoration institution in the making.</p>
        </div>
      </div>
    </footer>
  );
}
